var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-tabs"},[_vm._t("default"),_c('span',{ref:"highlight",staticClass:"v-tab-link-highlight init"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }